import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { Navigate } from 'react-router';
import { ELevelResult, } from 'Shared/types';
import { PageView } from 'Common/components/PageView/PageView';
import Header from 'Common/components/Header/Header';
import LevelResultsViews from 'PhenotypeView/views';
import { DatasetControl } from 'Datasets/components';
import PhenotypeViewTabs from '../PhenotypeViewTabs';
const Page = ({ onDatasetChange: handleDatasetChange, levelResult, pageName, isRoutesMatch, referrerState, phenotypeId, phenotypeName, }) => {
    const LevelResultsView = levelResult && LevelResultsViews[levelResult];
    return (_jsxs(PageView, Object.assign({ pageName: pageName, referrerState: referrerState }, { children: [_jsx(Header, Object.assign({ referrerState: referrerState }, { children: _jsx(DatasetControl, { onChange: handleDatasetChange }, void 0) }), void 0), _jsxs(PhenotypeViewTabs, { children: [LevelResultsView && _jsx(LevelResultsView, {}, void 0), isRoutesMatch && (_jsx(Navigate, { to: ELevelResult.Gene, state: {
                            referrerData: {
                                phenotypeName,
                                phenotypeId,
                            },
                        } }, void 0))] }, void 0)] }), void 0));
};
export default memo(Page);
